export const KPI_WEIGHTS = {
  finance_risk: 25,
  operational_risk: 25,
  quality_counterfeit_risk: 25,
  vendor_relationship_performance_risk: 25,
  avg_request_activity: 0,
  total_incidents: 0,
};

export const KPI_COLUMNS = [
  { key: 'finance_risk', label: 'Finance Risk', isPct: true },
  { key: 'operational_risk', label: 'Operational Risk', isPct: true },
  { key: 'quality_counterfeit_risk', label: 'Quality & counterfeit risk', isPct: true },
  { key: 'vendor_relationship_performance_risk', label: 'Vendor relationship & performance risk', isPct: true },
  { key: 'avg_request_activity', label: 'Average Request Activity', isPct: true },
  { key: 'total_incidents', label: 'Total Incidents Created', isPct: false },
];

/** First four weighted KPIs shown on score / detail breakdowns */
export const CORE_KPI_COLUMNS = KPI_COLUMNS.slice(0, 4);
export const CORE_KPI_KEYS = CORE_KPI_COLUMNS.map((c) => c.key);

export function kpiStatus(pct) {
  if (pct == null || Number.isNaN(pct)) return 'neutral';
  const v = Number(pct);
  if (v >= 80) return 'good';
  if (v >= 60) return 'warn';
  return 'bad';
}

export function formatPct(v) {
  if (v == null) return '—';
  return `${Number(v).toFixed(2)}%`;
}

export function defaultDateRange() {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 5);
  return {
    start_date: start.toISOString().slice(0, 10),
    end_date: end.toISOString().slice(0, 10),
  };
}
